import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { PERMISSION_KEYS } from '../../config/permissions'
import {
  adminNavLink,
  adminSectionClass,
  adminSectionHeaderClass,
  adminSectionMainClass,
  adminSectionNavClass,
  cn,
  pageTitleClass,
} from '../../lib/ui'

/** Раздел «Администрирование»: боковое меню + контент выбранного подраздела. */
export function AdministrationLayout() {
  const { can } = useAuth()
  const showUsers = can(PERMISSION_KEYS.USERS_READ)
  const showRoles = can(PERMISSION_KEYS.ROLES_READ)
  const showCategories = can(PERMISSION_KEYS.CONSUMABLES_READ) || can(PERMISSION_KEYS.PRODUCTS_READ)
  const showMachines = can(PERMISSION_KEYS.MACHINES_READ)
  const showShifts = can(PERMISSION_KEYS.SHIFTS_READ)
  const showProductionWorkers = can(PERMISSION_KEYS.PRODUCTION_WORKERS_READ)
  const showCalendar = can(PERMISSION_KEYS.PRODUCTION_CALENDAR_READ)

  return (
    <div className={adminSectionClass}>
      <header className={adminSectionHeaderClass}>
        <h1 className={cn(pageTitleClass, 'text-[1.35rem]')}>Администрирование</h1>
      </header>

      <aside className={adminSectionNavClass} aria-label="Разделы администрирования">
        <nav className="flex flex-col gap-0.5 max-md:flex-row max-md:flex-wrap max-md:gap-1.5">
          <NavLink
            to="/admin/administration/panel"
            end
            className={({ isActive }) => adminNavLink(isActive, true)}
          >
            Панель
          </NavLink>
          {showUsers && (
            <NavLink
              to="/admin/administration/employees"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Пользователи
            </NavLink>
          )}
          {showRoles && (
            <NavLink
              to="/admin/administration/roles"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Роли
            </NavLink>
          )}
          {showCategories && (
            <NavLink
              to="/admin/administration/categories"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Категории
            </NavLink>
          )}
          {showMachines && (
            <NavLink
              to="/admin/administration/machines"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Станки
            </NavLink>
          )}
          {showShifts && (
            <NavLink
              to="/admin/administration/shifts"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Смены
            </NavLink>
          )}
          {showProductionWorkers && (
            <NavLink
              to="/admin/administration/production-workers"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Сотрудники производства
            </NavLink>
          )}
          {showCalendar && (
            <NavLink
              to="/admin/administration/calendar"
              className={({ isActive }) => adminNavLink(isActive, true)}
            >
              Календарь
            </NavLink>
          )}
        </nav>
      </aside>

      <div className={adminSectionMainClass}>
        <Outlet />
      </div>
    </div>
  )
}
